import React from 'react';
import { PageName } from '../../shared/types';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import { SimpleMultiDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import Api from '../../lib/api';
import { useQueryClient } from '@tanstack/react-query';
import { toDropdownOption } from 'shared/utils/formUtils';

type Props = {
  apiClient: Api;
  pageName: PageName;
};

const StagesDropdown = ({ apiClient, pageName }: Props) => {
  const queryClient = useQueryClient();
  const { watch, setValue } = useFormContext();
  const selectedStages: Item[] | null = watch('stages');

  const t = withLocalePrefix(`talent_${pageName}.labels`);

  const fetchItems = async (term: string) => {
    const queryKey = ['stages', term];
    let items: Item[] = [];

    const cachedData: Item[] | null | undefined =
      queryClient.getQueryData(queryKey);

    if (cachedData) {
      items = cachedData;
    } else {
      items = await queryClient.fetchQuery({
        queryKey,
        queryFn: async () => {
          const stages = await apiClient.fetchStages(term);
          return stages.map(toDropdownOption) as Item[];
        },
      });
    }

    return { items };
  };

  return (
    <SimpleMultiDropdown
      label={t('stage_reached')}
      fetchItems={fetchItems}
      selectedItems={selectedStages}
      onSelectedItemsChange={(selectedItems) =>
        setValue('stages', selectedItems, { shouldDirty: true })
      }
      preventLoadOnMount={true}
    />
  );
};

export default StagesDropdown;
